import { Injectable } from '@angular/core';

import { Action, ActionReducer, MetaReducer } from '@ngrx/store';

import { AppState } from '../interfaces/app-state.interface';

/**
 * Lets lazy-loaded features run a reducer over the whole state tree before the feature reducers,
 * for state that spans several feature slices.
 */
@Injectable({ providedIn: 'root' })
export class CrossFeatureReducerRegistry {
  private readonly reducers = new Set<ActionReducer<AppState>>();

  register<S extends AppState>(reducer: ActionReducer<S>): void {
    this.reducers.add(reducer as ActionReducer<AppState>);
  }

  reduce(state: AppState | undefined, action: Action): AppState | undefined {
    return [...this.reducers].reduce((current, reducer) => reducer(current, action), state);
  }
}

export function crossFeatureMetaReducer(registry: CrossFeatureReducerRegistry): MetaReducer<AppState> {
  return (reducer: ActionReducer<AppState>): ActionReducer<AppState> =>
    (state, action) =>
      reducer(registry.reduce(state, action), action);
}
